export default {
  name: 'chenzhou',
  adcode: '431000',
  mapName: '郴州市',
  geoJsonPath: 'hunanmap/431000.json',
  backgroundImage: {
    png: '郴州市_431000.png',
    webp: '郴州市_431000.webp'
  },
  echartsMapStyle: {
    width: '740px',
    height: '743px',
    marginTop: 'auto',
    marginBottom: '32px',
  },
  imageSize: {
    width: 3416,
    height: 3430
  },
  // 区县列表
  districts: ['郴州市区', '资兴市', '桂阳县', '宜章县', '永兴县', '嘉禾县', '临武县', '汝城县', '桂东县', '安仁县'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    '郴州市区': [112.9017, 25.7406],
    '郴州市': [112.9017, 25.7406],
    '资兴市': [113.3270, 25.9350],
    '桂阳县': [112.5900, 25.8640],
    '宜章县': [112.8380, 25.4190],
    '永兴县': [113.1230, 26.2180],
    '嘉禾县': [112.3090, 25.6280],
    '临武县': [112.4820, 25.3560],
    '汝城县': [113.5950, 25.5470],
    '桂东县': [113.7440, 25.9070],
    '安仁县': [113.2690, 26.5490]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '郴州市') return '郴州市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '北湖区': '431002',
    '苏仙区': '431003',
    '资兴市': '431081',
    '桂阳县': '431021',
    '宜章县': '431022',
    '永兴县': '431023',
    '嘉禾县': '431024',
    '临武县': '431025',
    '汝城县': '431026',
    '桂东县': '431027',
    '安仁县': '431028'
  }
}